import { Chapter } from '../types/game';

export const gameData: Chapter[] = [
  {
    id: 'chapter-1',
    name: 'The Dream',
    number: 1,
    description: 'Ida begins her journey through impossible architecture',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe',
    videoUrl: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=1',
    levels: [
      {
        id: 'level-1-1',
        name: 'The Opening',
        chapter: 'The Dream',
        chapterNumber: 1,
        levelNumber: 1,
        description: 'Introduction to Monument Valley 3',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk',
        difficulty: 'easy',
        tags: ['Tutorial', 'Introduction']
      },
      {
        id: 'level-1-2',
        name: 'First Steps',
        chapter: 'The Dream',
        chapterNumber: 1,
        levelNumber: 2,
        description: 'Learn the basic controls and mechanisms',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?start=120',
        difficulty: 'easy',
        tags: ['Tutorial', 'Controls']
      },
      {
        id: 'level-1-3',
        name: 'Easy Puzzles',
        chapter: 'The Dream',
        chapterNumber: 1,
        levelNumber: 3,
        description: 'Simple illusions to understand the mechanics',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?start=240',
        difficulty: 'easy',
        tags: ['Puzzle', 'Illusion']
      },
      {
        id: 'level-1-4',
        name: 'Path Creation',
        chapter: 'The Dream',
        chapterNumber: 1,
        levelNumber: 4,
        description: 'Create paths through impossible geometry',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?start=360',
        difficulty: 'medium',
        tags: ['Path', 'Creation', 'Rotation']
      }
    ]
  },
  {
    id: 'chapter-2',
    name: 'Illusory Forest',
    number: 2,
    description: 'Navigate through the mystical forest of illusions',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=2',
    videoUrl: 'https://www.youtube.com/watch?v=_NLvtv5tcOY&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=2',
    levels: [
      {
        id: 'level-2-1',
        name: 'Forest Path',
        chapter: 'Illusory Forest',
        chapterNumber: 2,
        levelNumber: 1,
        description: 'Find the hidden path through trees',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=2',
        difficulty: 'medium',
        tags: ['Forest', 'Navigation']
      },
      {
        id: 'level-2-2',
        name: 'Tree Shadows',
        chapter: 'Illusory Forest',
        chapterNumber: 2,
        levelNumber: 2,
        description: 'Use shadows to reveal new paths',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=3',
        difficulty: 'medium',
        tags: ['Shadows', 'Light']
      },
      {
        id: 'level-2-3',
        name: 'Canal Crossing',
        chapter: 'Illusory Forest',
        chapterNumber: 2,
        levelNumber: 3,
        description: 'Build bridges across impossible water',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=4',
        difficulty: 'hard',
        tags: ['Water', 'Bridges', 'Construction']
      }
    ]
  },
  {
    id: 'chapter-3',
    name: 'Crystal Caverns',
    number: 3,
    description: 'Explore the underground crystal formations',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=5',
    videoUrl: 'https://www.youtube.com/watch?v=Adwm7i5u5kQ&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=3',
    levels: [
      {
        id: 'level-3-1',
        name: 'Crystal Growth',
        chapter: 'Crystal Caverns',
        chapterNumber: 3,
        levelNumber: 1,
        description: 'Guide crystal growth to create platforms',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=5',
        difficulty: 'medium',
        tags: ['Crystals', 'Growth']
      },
      {
        id: 'level-3-2',
        name: 'Light Refraction',
        chapter: 'Crystal Caverns',
        chapterNumber: 3,
        levelNumber: 2,
        description: 'Use crystal light to bend perspectives',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=6',
        difficulty: 'hard',
        tags: ['Light', 'Refraction', 'Optics']
      },
      {
        id: 'level-3-3',
        name: 'Echo Cave',
        chapter: 'Crystal Caverns',
        chapterNumber: 3,
        levelNumber: 3,
        description: 'Navigate using sound echoes',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=7',
        difficulty: 'medium',
        tags: ['Sound', 'Echo', 'Navigation']
      }
    ]
  },
  {
    id: 'chapter-4',
    name: 'Sky Temple',
    number: 4,
    description: 'Ascend to the ancient temple in the sky',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=8',
    videoUrl: 'https://www.youtube.com/watch?v=DM92nyjUvPs&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=4',
    levels: [
      {
        id: 'level-4-1',
        name: 'Floating Platforms',
        chapter: 'Sky Temple',
        chapterNumber: 4,
        levelNumber: 1,
        description: 'Manipulate floating temple platforms',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=8',
        difficulty: 'medium',
        tags: ['Floating', 'Platforms', 'Sky']
      },
      {
        id: 'level-4-2',
        name: 'Prismatic Lights',
        chapter: 'Sky Temple',
        chapterNumber: 4,
        levelNumber: 2,
        description: 'Use colored lights to solve puzzles',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=9',
        difficulty: 'hard',
        tags: ['Light', 'Prism', 'Color']
      },
      {
        id: 'level-4-3',
        name: 'Temple Gateway',
        chapter: 'Sky Temple',
        chapterNumber: 4,
        levelNumber: 3,
        description: 'Unlock the sacred temple entrance',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=10',
        difficulty: 'medium',
        tags: ['Temple', 'Gateway', 'Ritual']
      }
    ]
  },
  {
    id: 'chapter-5',
    name: 'Ocean Dreams',
    number: 5,
    description: 'Dive into the surreal underwater world',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=11',
    videoUrl: 'https://www.youtube.com/watch?v=kjWOxjyigd4&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=5',
    levels: [
      {
        id: 'level-5-1',
        name: 'Underwater Path',
        chapter: 'Ocean Dreams',
        chapterNumber: 5,
        levelNumber: 1,
        description: 'Create paths through the ocean',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=11',
        difficulty: 'medium',
        tags: ['Ocean', 'Underwater', 'Paths']
      },
      {
        id: 'level-5-2',
        name: 'Tidal Controls',
        chapter: 'Ocean Dreams',
        chapterNumber: 5,
        levelNumber: 2,
        description: 'Master the power of tides',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=12',
        difficulty: 'hard',
        tags: ['Tides', 'Water', 'Timing']
      },
      {
        id: 'level-5-3',
        name: 'Coral Gardens',
        chapter: 'Ocean Dreams',
        chapterNumber: 5,
        levelNumber: 3,
        description: 'Cultivate coral to create platforms',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=13',
        difficulty: 'medium',
        tags: ['Coral', 'Gardens', 'Growth']
      }
    ]
  },
  {
    id: 'chapter-6',
    name: 'The Artist',
    number: 6,
    description: 'Explore the creative workshop of the artist',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=14',
    videoUrl: 'https://www.youtube.com/watch?v=YRGeHf1E3JI&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=6',
    levels: [
      {
        id: 'level-6-1',
        name: 'Painted Reality',
        chapter: 'The Artist',
        chapterNumber: 6,
        levelNumber: 1,
        description: 'Paint the world into existence',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=14',
        difficulty: 'medium',
        tags: ['Painting', 'Creation', 'Art']
      },
      {
        'id': 'level-6-2',
        name: 'Color Symphony',
        chapter: 'The Artist',
        chapterNumber: 6,
        levelNumber: 2,
        description: 'Create harmony through color manipulation',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYxG-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=15',
        difficulty: 'hard',
        tags: ['Colors', 'Symphony', 'Harmony']
      },
      {
        id: 'level-6-3',
        name: 'The Creator',
        chapter: 'The Artist',
        chapterNumber: 6,
        levelNumber: 3,
        description: 'Meet the mysterious creator',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=16',
        difficulty: 'medium',
        tags: ['Creator', 'Mystery', 'Finale']
      }
    ]
  },
  {
    id: 'chapter-7',
    name: 'Time Maze',
    number: 7,
    description: 'Navigate through temporal paradoxes',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=17',
    videoUrl: 'https://www.youtube.com/watch?v=zL0Wzy27Hpc&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=7',
    levels: [
      {
        id: 'level-7-1',
        name: 'Past and Present',
        chapter: 'Time Maze',
        chapterNumber: 7,
        levelNumber: 1,
        description: 'Navigate through time itself',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYx-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=17',
        difficulty: 'hard',
        tags: ['Time', 'Paradox', 'Navigation']
      },
      {
        id: 'level-7-2',
        name: 'Future Echoes',
        chapter: 'Time Maze',
        chapterNumber: 7,
        levelNumber: 2,
        description: 'Manipulate future events to solve puzzles',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYx-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=18',
        difficulty: 'hard',
        tags: ['Future', 'Echoes', 'Prediction']
      },
      {
        id: 'level-7-3',
        name: 'Time Convergence',
        chapter: 'Time Maze',
        chapterNumber: 7,
        levelNumber: 3,
        description: 'Bring past and future together',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYx-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=19',
        difficulty: 'hard',
        tags: ['Time', 'Convergence', 'Unification']
      }
    ]
  },
  {
    id: 'chapter-8',
    name: 'Final Journey',
    number: 8,
    description: 'The ultimate test of all lessons learned',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYxG-bk&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=18',
    videoUrl: 'https://www.youtube.com/watch?v=Vn8ByWF4Dkg&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=8',
    levels: [
      {
        id: 'level-8-1',
        name: 'Final Challenge',
        chapter: 'Final Journey',
        chapterNumber: 8,
        levelNumber: 1,
        description: 'Face the ultimate architectural challenge',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYxG-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=20',
        difficulty: 'hard',
        tags: ['Final', 'Challenge', 'Test']
      },
      {
        id: 'level-8-2',
        name: 'All Paths Converge',
        chapter: 'Final Journey',
        chapterNumber: 8,
        levelNumber: 2,
        description: 'All your skills come together',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYx-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=21',
        difficulty: 'hard',
        tags: ['Convergence', 'Mastery', 'Integration']
      }
    ]
  },
  {
    id: 'chapter-9',
    name: 'Beyond Dreams',
    number: 9,
    description: 'Transcend into pure imagination',
    youtubePlaylist: 'https://www.youtube.com/watch?v=z_UVGYx-bk&list=PLi8se668bgk6_2HOAFMHhX6mwTQOpiwyYe&index=22',
    videoUrl: 'https://www.youtube.com/watch?v=OjpHtwDVZuU&list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=9',
    levels: [
      {
        id: 'level-9-1',
        name: 'Dream Reality',
        chapter: 'Beyond Dreams',
        chapterNumber: 9,
        levelNumber: 1,
        description: 'The final transcendence moment',
        thumbnail: 'https://img.youtube.com/vi/z_UVGYx-bk/mqdefault.jpg',
        videoUrl: 'https://www.youtube.com/embed/z_UVGYx-bk?list=PLi8se668bgk6_2HOAFMhX6mwTQOpiwyYe&index=22',
        difficulty: 'hard',
        tags: ['Transcendence', 'Dreams', 'Finale']
      }
    ]
  }
];